import { Location } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ApplicationTypeService } from "../../services/ApplicationTypeService";
import { TechnologyCategoryService } from "../../services/TechnologyCategoryService";
import { NavBarViewModel } from "./nav-bar.view-model";

@Component({
	selector: "nav-bar-view",
	templateUrl: "./nav-bar.component.html",
	styleUrls: ["./nav-bar.component.scss"],
})
export class NavBarComponent implements OnInit {

	public viewModel: NavBarViewModel;
	public routeUrl: string;

	private readonly applicationTypeService: ApplicationTypeService;
	private readonly location: Location;
	private readonly technologyCategoryService: TechnologyCategoryService;

	private constructor(applicationTypeService: ApplicationTypeService, location: Location, technologyCategoryService: TechnologyCategoryService) {
		this.applicationTypeService = applicationTypeService;
		this.location = location;
		this.technologyCategoryService = technologyCategoryService;
	}

	public ngOnInit(): void {
		this.routeUrl = this.location.path();
		window.setInterval(() => {
			this.routeUrl = this.location.path();
		},                 500);
		this.location.subscribe((value) => {
			this.routeUrl = value.url;
		});

		this.ngOnInitAsync().catch((reason: Error) => {
			console.error(reason.message);
		});

	}

	public comparePages(): boolean {
		if (this.routeUrl !== "/showroom"
			&& this.routeUrl.indexOf("/technologies") === -1
			&& this.routeUrl.indexOf("/technology") === -1
			&& this.routeUrl.indexOf("/applicationTypes") === -1) {
			return true;
		} else {
			return false;
		}
	}

	public href(url: string): void {
		window.location.href = url;
	}

	public async ngOnInitAsync(): Promise<void> {
		this.viewModel = {
			applicationTypesViewModel: await this.applicationTypeService.getNavHomeComponentAsync(),
			technologyCategoriesNavHomeViewModel: await this.technologyCategoryService.getNavHomeComponentAsync(),
		};
	}

}



// WEBPACK FOOTER //
// ./Frontend/src/app/components/nav-bar/nav-bar.component.ts